/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import NavElements from 'flarum/newvigation/components/NavElements';
import LinkButton from 'flarum/common/components/LinkButton';
import TagLinkButton from 'flarum/tags/components/TagLinkButton';
import type Tag from 'flarum/tags/common/models/Tag';

export default function () {
	const navLink = (active: boolean) => (
		<LinkButton href={app.route.reviews()} icon="far fa-heart" active={active}>
			{app.translator.trans('glowingblue-orell-rezensionen.forum.reviews.nav')}
		</LinkButton>
	);

	const currentRoute = () => m.route.get() || '';

	const isReviewsPage = () => currentRoute().indexOf('/reviews') === 0;

	if (app.initializers.has('glowingblue-newvigation')) {
		extend(NavElements.prototype, 'items', function (items) {
			items.add('reviews', navLink(isReviewsPage()), 141);
		});

		extend(NavElements.prototype, 'oncreate', function () {
			this.$('.Header-controls li a').each((_i: number, element: HTMLElement) => {
				// The selector only ever matches anchors, which jQuery's callback types as `HTMLElement`.
				const item = element as HTMLAnchorElement;

				try {
					const url = new URL(item.href);
					const rootPath = url.pathname.split('/')[1];
					const currentRootPath = currentRoute().split('/')[1];

					if (rootPath === 'reviews' && currentRootPath === 'r') {
						$(item).addClass('active');
					}
				} catch (e) {}
			});
		});
	} else {
		extend(IndexPage.prototype, 'navItems', function (items) {
			items.add('reviews', navLink(isReviewsPage()), 91);
		});
	}

	extend(TagLinkButton, 'initAttrs', function (_, attrs) {
		if (!isReviewsPage()) {
			return;
		}

		// `Component.initAttrs()` is typed `(attrs: unknown)`; it mutates the attrs object in place.
		const linkAttrs = attrs as { model: Tag; route?: string };
		const tag = linkAttrs.model;

		// Point tag links at the reviews list rather than the discussion list.
		linkAttrs.route = app.route.reviews_tag(tag);
	});
}
